import { render, staticRenderFns } from "./ShowTask.vue?vue&type=template&id=dbc4c69e&scoped=true"
import script from "./ShowTask.vue?vue&type=script&lang=js"
export * from "./ShowTask.vue?vue&type=script&lang=js"
import style0 from "./ShowTask.vue?vue&type=style&index=0&id=dbc4c69e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc4c69e",
  null
  
)

export default component.exports